/**
 * Checks if the provided canonical URL is valid.
 * Returns false if the URL is empty, contains 'undefined', or contains 'null'.
 *
 * @param {string} canonicalUrl - The canonical URL to validate.
 * @returns {boolean} True if valid, false otherwise.
 */
export const isCanonicalUrlValid = (canonicalUrl) => {
  if (!canonicalUrl) return false;
  if (canonicalUrl.includes('undefined')) return false;
  if (canonicalUrl.includes('null')) return false;

  return true;
};

/**
 * Checks if the provided object is valid.
 * Returns false if the object is falsy or has no own properties.
 *
 * @param {Object} obj - The object to validate.
 * @returns {boolean} True if valid, false otherwise.
 */
export const isObjectValid = (obj) => {
  if (!obj) return false;
  if (Object.keys(obj).length === 0) return false;

  return true;
};

/**
 * Checks if the provided title is valid.
 * Returns false if the title is empty or only whitespace.
 *
 * @param {string} title - The title to validate.
 * @returns {boolean} True if valid, false otherwise.
 */
export const isTitleValid = (title) => {
  if (!title) return false;
  if (title.trim() === '') return false;

  return true;
};
